import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-requisitions',
  templateUrl: './requisitions.component.html',
  styleUrls: ['./requisitions.component.css']
})
export class RequisitionsComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlacesFrom: StockplaceItem[] = [];

    public selectListStockPlacesTo: StockplaceItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {}

    private async loadSetting() {
        this.setting = (await this.datatask.Post(764))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_from':
                this.selectListStockPlacesFrom = await this.logistic.getStockplaces({
                    businessco_no: this.setting.businessco_no_from,
                    add_all: 'ALL'
                });
                break;
            case 'businessco_no_to':
                this.selectListStockPlacesTo = await this.logistic.getStockplaces({
                    businessco_no: this.setting.businessco_no_to,
                    add_all: 'ALL'
                });
                break;
            default:
                break;
        };
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting?.view_id)
                    .setLoadDataFunction({
                        method: this.setting!.p2_datatask_keyno,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_from':
            case 'businessco_no_to':
                this.loadStockPlaces('businessco_no_from');
                break;
            case 'stockplace_id_from':
            case 'stockplace_id_to':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        return Promise.all([
            this.loadStockPlaces('businessco_no_from'),
            this.loadStockPlaces('businessco_no_to')
        ]).then(() => {
            this.loadGrid();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no_from: string;
    stockplace_id_from: string;
    businessco_no_to: string;
    stockplace_id_to: string;
    p2_datatask_keyno: number;
    view_id: string;
}
